import mattilsynet from './mattilsynet'
import snowchat from './snowchat'
import lab from './lab'
import rusinfo from './rusinfo'
import felleskatalogen from './felleskatalogen'
import diabetes from './diabetes'
import helsebiblioteket from './helsebiblioteket'
import helsebiblioteket_pasient from './helsebiblioteket_pasient'
import pediatri_koble from './pediatri_koble'

const configs = {
  mattilsynet,
  rusinfo,
  snowchat,
  lab,
  felleskatalogen,
  diabetes,
  helsebiblioteket,
  helsebiblioteket_pasient,
  pediatri_koble,
}

export default configs
